import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0c2b458"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slide" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/slide-1.png" }),
  /*#__PURE__*/_createElementVNode("h2", null, "Welcome"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" The "),
    /*#__PURE__*/_createElementVNode("b", null, "ionic conference app"),
    /*#__PURE__*/_createTextVNode(" is a practical preview of the ionic framework in action, and a demonstration of proper code use. ")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/slide-2.png" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "What is Ionic?", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Ionic Framework"),
  /*#__PURE__*/_createTextVNode(" is an open source SDK that enables developers to build high quality mobile apps with web technologies like HTML, CSS, and JavaScript. ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/slide-3.png" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "What is Appflow?", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Appflow"),
  /*#__PURE__*/_createTextVNode(" is a powerful set of services and features built on top of Ionic Framework that brings a totally new level of app development agility to mobile dev teams. ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/slide-4.png" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Ready to Play?", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Continue ")


	import { IonSlides, IonSlide, IonButton, IonIcon } from "@ionic/vue";
	import { defineComponent } from 'vue';
	import { arrowForward } from 'ionicons/icons';
	const __default__ = defineComponent({
		name: 'IntroPage',
		components: { IonSlides, IonSlide, IonButton, IonIcon },
		setup()
		{
			return { arrowForward }
		},
		methods: {
			skipIntroPage()
			{
				localStorage.setItem('skip_intro', '1');
				window.location.href = '/';
			}
		}
	});
import { useI18n } from 'vue-i18n'
	
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const { t } = useI18n({
		inheritLocale: true,
		useScope: 'global'
	})

return (_ctx: any,_cache: any) => {
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, {
    fullscreen: "",
    "scroll-y": "false"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSlides), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonSlide), null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_unref(IonSlide), null, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_unref(IonSlide), null, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_unref(IonSlide), null, {
            default: _withCtx(() => [
              _hoisted_8,
              _hoisted_9,
              _createVNode(_unref(IonButton), {
                fill: "clear",
                onClick: _ctx.skipIntroPage
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(arrowForward),
                    slot: "end"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})